import { useEffect } from "react";
import Chart from "chart.js/auto";

import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import Footer from "../components/Footer" 
import "./dashboard.css";

export default function Dashboard() {

  useEffect(() => {
    const salesChart = new Chart(
      document.getElementById("salesChart"),
      {
        type: "line",
        data: {
          labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
          datasets: [
            {
              label: "Revenue",
              data: [12000, 15000, 18000, 22000, 28000, 35000, 45200],
              borderColor: "#008dd2",
              backgroundColor: "rgba(0,141,210,0.25)",
              fill: true,
              tension: 0.4,
              pointRadius: 4
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false }
          }
        }
      }
    );

    const statusChart = new Chart(
      document.getElementById("statusChart"),
      {
        type: "doughnut",
        data: {
          labels: ["Completed", "Pending", "Cancelled"],
          datasets: [
            {
              data: [920, 260, 100],
              backgroundColor: ["#38ef7d", "#ffd200", "#ff4d4d"],
              borderWidth: 0
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          cutout: "70%",
          plugins: {
            legend: {
              position: "bottom",
              labels: { boxWidth: 10 }
            }
          }
        }
      }
    );

    return () => {
      salesChart.destroy();
      statusChart.destroy();
    };
  }, []);

  

  return (
    <div className="admin-body">
      <Topbar/>
      <Sidebar/>

      <main className="admin-main">
        <h1 className="page-title">Dashboard</h1>

        {/* STATS */}
        <section className="stats-grid">
          <div className="stat-card blue">
            <h4>Total Revenue</h4>
            <h2>45,200</h2>
            <span>↑ 12% this month</span>
          </div>

          <div className="stat-card green">
            <h4>Orders</h4>
            <h2>1,280</h2>
            <span>↑ 8% this month</span>
          </div>

          <div className="stat-card purple">
            <h4>Products</h4>
            <h2>54</h2>
            <span>Active items</span>
          </div>

          <div className="stat-card orange">
            <h4>RFQs</h4>
            <h2>16</h2>
            <span>New requests</span>
          </div>
        </section>

        {/* CHARTS */}
        <section className="charts-grid">
          <div className="chart-card large">
            <h3>Sales Overview</h3>
            <canvas id="salesChart"></canvas>
          </div>

          <div className="chart-card">
            <h3>Order Status</h3>
            <canvas id="statusChart"></canvas>
          </div>
        </section>
      </main>
      <Footer/>
    </div>
  );
}
